/**
 * Headless runtime that keeps mission TLEs fresh while the shared clock is at
 * present time. Mounted once by the Shell; renders nothing.
 */
import { useEffect } from 'react';
import { createLoaderLiveTleScheduler } from './liveTleRefresh';
import { isFrozen } from '@/features/presenter';

export function LiveTleRuntime() {
  useEffect(() => {
    const scheduler = createLoaderLiveTleScheduler({ isFrozen });
    scheduler.start();
    return () => scheduler.stop();
  }, []);
  return null;
}
